import { render, staticRenderFns } from "./BusinessViewSendMessage.vue?vue&type=template&id=12031b69&"
import script from "./BusinessViewSendMessage.vue?vue&type=script&lang=js&"
export * from "./BusinessViewSendMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
